import Vue from 'vue';

import {
  Pagination,
  Menu,MenuItem,Submenu,
  Button,
  Row,Col,
  Tabs,TabPane,
  Form,FormItem,
  Input,
  Skeleton,SkeletonItem,
  Drawer
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../styles/main.css'
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Drawer)